import { render } from "./TopHeader.vue?vue&type=template&id=3985e5d0&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=3985e5d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3985e5d0"]])

export default __exports__